import axios from 'axios';

// ApiAccess Functions
export const verifyFoIdtoken = async (headers) => {
  let retParam;
  try {
    const NoDataheader = headers;
    // await axios
    // .get(`${process.env.REACT_APP_FINDOUT_LOCAL_API_URL}/user2-ssoApp/auth/profile`, { headers: NoDataheader })
    // .then((result) => {
    await axios.get(`${process.env.REACT_APP_FINDOUT_API_URL}/user2-ssoApp/auth/profile`, { headers: NoDataheader }).then((result) => {
      retParam = result;
    });
  } catch (e) {
    if (e.statusCode === 401) {
      // findout authユーザの情報取得に失敗
    }
    if (e.statusCode === 500) {
      // findout authユーザの情報取得に失敗
    }
  }
  return retParam;
};

export const revokeIdtoken = async (headers, data = {}) => {
  let retParam;
  try {
    const url = `${process.env.REACT_APP_FINDOUT_API_URL}/user2-ssoApp/logout`;
    await axios
      .post(url, data, {
        headers
      })
      .then((result) => {
        retParam = result;
      });
  } catch (e) {
    if (e.statusCode === 401) {
      retParam = e;
      return retParam;
    }
    if (e.statusCode === 500) {
      retParam = e;
      return retParam;
    }
    retParam = e;
    return retParam;
  }
  return retParam;
};

export const deleteAuth = async (headers, data) => {
  let retParam;
  try {
    const url = `${process.env.REACT_APP_FINDOUT_API_URL}/user2-ssoApp/deleteAuthRecord`;
    await axios
      .post(url, data, {
        headers
      })
      .then((result) => {
        retParam = result;
      });
    return retParam;
  } catch (e) {
    retParam = e;
    return retParam;
  }
};

export const getArticle = async (headers, data) => {
  let retParam;
  try {
    const url = `${process.env.REACT_APP_FINDOUT_API_URL}/user2-ssoApp/getArticle`;
    await axios
      .post(url, data, {
        headers
      })
      .then((result) => {
        retParam = result;
      });
    return retParam;
  } catch (e) {
    retParam = e;
    return retParam;
  }
};
